// 测试路由

// 测试页面
const CoachTest = () => import(/* webpackChunkName: "CoachTest" */ '@/components/coach-test/paper.vue')

// 测试结束页面
const CoachTestEnd = () => import(/* webpackChunkName: "CoachTest" */ '@/components/coach-test/end.vue')

export default [
  {
    path: '/CoachTest',
    name: 'CoachTest',
    component: CoachTest
  },
  {
    path: '/CoachTestEnd',
    name: 'CoachTestEnd',
    component: CoachTestEnd
  }
]



// WEBPACK FOOTER //
// ./src/router/index-test.js